import { ApplicationActivity } from "../types";
import { combinedRoles } from "../constants";
import { getFullName } from "shared/utils/get-full-name";

const titles = {
  identity_verification_rerun_requested: "Identity re-verification request",
  identity_verification_rerun_completed: "Identity re-verification",
  identity_verification_rerun_canceled: "Identity re-verification request"
} as const;

const actions = {
  identity_verification_rerun_requested: "was sent",
  identity_verification_rerun_completed: "was completed",
  identity_verification_rerun_canceled: "was canceled"
} as const;

// "to" for a request the applicant still has to act on, "for" once the outcome
// is decided by the partner.
const contactPrepositions = {
  identity_verification_rerun_requested: "To",
  identity_verification_rerun_completed: undefined,
  identity_verification_rerun_canceled: "For"
} as const;

type IdentityVerificationRerunActivityType = keyof typeof titles;

export const IdentityVerificationRerun = ({
  activityItem
}: {
  activityItem: ApplicationActivity;
}) => {
  const activityType =
    activityItem.activity_type as IdentityVerificationRerunActivityType;
  const contact = activityItem.details?.contact;
  const contactPreposition = contactPrepositions[activityType];

  return (
    <div className="space-y-2">
      <p className="text-base font-bold text-content-1000">
        {titles[activityType]}{" "}
        <span className="font-normal">
          {actions[activityType]}
          {activityItem.author?.name ? ` by ${activityItem.author.name}` : null}
        </span>
      </p>
      {contact && contactPreposition ? (
        <p className="text-sm font-normal text-content-400">
          {contactPreposition}{" "}
          {getFullName({
            firstName: contact.first_name,
            lastName: contact.last_name,
            middleName: contact.middle_name,
            short: true
          })}{" "}
          ({contact.role ? combinedRoles[contact.role] : "-"})
        </p>
      ) : null}
    </div>
  );
};
